import React from 'react';

import {Item, useItemQuery} from '../../../../generated/types';
import {getItemSubTitle} from '../../../render-helpers';
import {Link} from '../../../../lib/routes';
import {Markdown} from '../markdown';
import {MarkdownPlugin} from './plugin';

import css from './statblock.plugin.module.css';

type Props = {
	args: string[];
};

// {@item-block item-id} — карточка магического предмета целиком
export const ItemBlockPlugin: MarkdownPlugin<Props> = ({args}) => {
	const [id] = args;
	const {data} = useItemQuery({variables: {id}, skip: !id});
	const item = data?.item;

	if (!item) return null;

	return (
		<div className={css.statblock}>
			<div className={css.header}>
				<Link route="item" params={{id}} className={css.title}>
					{item.title}
				</Link>
				<em className={css.subTitle}>{getItemSubTitle(item as Item)}</em>
			</div>
			<Markdown text={item.description || ''} />
		</div>
	);
};

// карточка, а не строчка текста: разбор ставит её отдельным блоком, а не внутрь абзаца
ItemBlockPlugin.block = true;
